var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataRepositoryInPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 86,
    y1: 48.35,
    x2: 86,
    y2: 23.037,
    gradientUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#737b80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575c61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 86,
    y1: 39.538,
    x2: 86,
    y2: 75.289,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 134.081,
    y1: 62.414,
    x2: 123.754,
    y2: 52.087,
    gradientUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 126.467,
    y1: 54.8,
    x2: 131.533,
    y2: 59.867,
    gradientUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 86,
    y1: 75.372,
    x2: 86,
    y2: 111.123,
    gradientUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 86,
    y1: 111.205,
    x2: 86,
    y2: 146.956,
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 134.081,
    y1: 98.248,
    x2: 123.754,
    y2: 87.921,
    gradientUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 134.081,
    y1: 134.081,
    x2: 123.754,
    y2: 123.754,
    gradientUnits: "userSpaceOnUse",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 126.467,
    y1: 126.467,
    x2: 131.533,
    y2: 131.533,
    gradientUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 126.757,
    cy: 90.741,
    r: 6.876,
    gradientUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a511"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    fill: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fillRule: "nonzero",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.53 22.478a7.17 7.17 0 0 0-6.678-4.561H37.148a7.17 7.17 0 0 0-6.679 4.561L22.446 43.05 86 46.583l63.554-3.53z",
    fill: "url(#a)",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.667 75.25h114.666c3.942 0 7.167-3.225 7.167-7.167v-21.5c0-3.941-3.225-7.166-7.167-7.166H28.667c-3.942 0-7.167 3.225-7.167 7.166v21.5c0 3.942 3.225 7.167 7.167 7.167z",
    fill: "url(#b)",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 57.333A7.17 7.17 0 0 1 129 64.5a7.17 7.17 0 0 1-7.167-7.167A7.17 7.17 0 0 1 129 50.167a7.17 7.17 0 0 1 7.167 7.166z",
    fill: "url(#c)",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.583 57.333A3.585 3.585 0 0 1 129 60.917a3.585 3.585 0 0 1-3.583-3.584A3.585 3.585 0 0 1 129 53.75a3.585 3.585 0 0 1 3.583 3.583z",
    fill: "url(#d)",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.333 111.083H28.667c-3.942 0-7.167-3.225-7.167-7.166v-21.5c0-3.942 3.225-7.167 7.167-7.167h114.666c3.942 0 7.167 3.225 7.167 7.167v21.5c0 3.941-3.225 7.166-7.167 7.166z",
    fill: "url(#e)",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.333 146.917H28.667c-3.942 0-7.167-3.225-7.167-7.167v-21.5c0-3.942 3.225-7.167 7.167-7.167h114.666c3.942 0 7.167 3.225 7.167 7.167v21.5c0 3.942-3.225 7.167-7.167 7.167z",
    fill: "url(#f)",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 93.167a7.17 7.17 0 0 1-7.167 7.166 7.17 7.17 0 0 1-7.167-7.166A7.17 7.17 0 0 1 129 86a7.17 7.17 0 0 1 7.167 7.167z",
    fill: "url(#g)",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.583 93.167A3.585 3.585 0 0 1 129 96.75a3.585 3.585 0 0 1-3.583-3.583A3.585 3.585 0 0 1 129 89.583a3.585 3.585 0 0 1 3.583 3.584z",
    fill: "url(#h)",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.167 129a7.17 7.17 0 0 1-7.167 7.167 7.17 7.17 0 0 1-7.167-7.167 7.17 7.17 0 0 1 7.167-7.167 7.17 7.17 0 0 1 7.167 7.167z",
    fill: "url(#i)",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.583 129a3.585 3.585 0 0 1-3.583 3.583 3.585 3.585 0 0 1-3.583-3.583 3.585 3.585 0 0 1 3.583-3.583 3.585 3.585 0 0 1 3.583 3.583z",
    fill: "url(#j)",
    style: {
      fill: "url(#j)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 53.75h68.083c.99 0 1.792.803 1.792 1.792v3.583c0 .989-.803 1.792-1.792 1.792H37.625a1.792 1.792 0 0 1-1.792-1.792v-3.583c0-.99.803-1.792 1.792-1.792zM37.625 89.583h68.083c.99 0 1.792.803 1.792 1.792v3.583c0 .99-.803 1.792-1.792 1.792H37.625a1.792 1.792 0 0 1-1.792-1.792v-3.583c0-.989.803-1.792 1.792-1.792zM37.625 125.417h68.083c.99 0 1.792.802 1.792 1.791v3.584c0 .989-.803 1.791-1.792 1.791H37.625a1.792 1.792 0 0 1-1.792-1.791v-3.584c0-.989.803-1.791 1.792-1.791z",
    fill: "#737b80"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-6.1l-2-2H6.5C5.7 5 5 5.7 5 6.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#cc8000",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 74.717 56.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-12C5.7 7 5 7.7 5 8.5v7c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#dba400",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 74.717 56.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-6.1l-2-2H6.5C5.7 5 5 5.7 5 6.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#e59000",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 56.721 72.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-12C5.7 7 5 7.7 5 8.5v7c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#f5b800",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 56.721 72.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-6.1l-2-2H6.5C5.7 5 5 5.7 5 6.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#ffa000"
    },
    transform: "matrix(4.66667 0 0 4.66667 37.794 89.933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-12C5.7 7 5 7.7 5 8.5v7c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#ffca28"
    },
    transform: "matrix(4.66667 0 0 4.66667 37.794 89.933)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRepositoryInPlace);
export default __webpack_public_path__ + "static/media/dataRepositoryInPlace.3723dbc1925722ca2e480e588da708d9.svg";
export { ForwardRef as ReactComponent };